<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="审核日期" prop="auditDate">
        <el-date-picker
          v-model="queryParams.auditDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择审核日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="审核类型" prop="auditType">
        <el-select
          v-model="queryParams.auditType"
          class="!w-240px"
          clearable
          placeholder="请选择审核类型"
        >
          <el-option label="日审" value="DAILY" />
          <el-option label="月审" value="MONTHLY" />
          <el-option label="年审" value="YEARLY" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          v-model="queryParams.status"
          class="!w-240px"
          clearable
          placeholder="请选择状态"
        >
          <el-option label="待执行" value="PENDING" />
          <el-option label="执行中" value="PROCESSING" />
          <el-option label="成功" value="SUCCESS" />
          <el-option label="失败" value="FAILED" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:night-audit:execute']"
          type="primary"
          @click="openExecuteDialog"
        >
          <Icon class="mr-5px" icon="ep:video-play" />
          执行夜审
        </el-button>
        <el-button
          v-hasPermi="['hotel:night-audit:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="审核日期" prop="auditDate" min-width="120" />
      <el-table-column align="center" label="审核类型" prop="auditType" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.auditType === 'DAILY'" type="primary">日审</el-tag>
          <el-tag v-else-if="scope.row.auditType === 'MONTHLY'" type="warning">月审</el-tag>
          <el-tag v-else-if="scope.row.auditType === 'YEARLY'" type="success">年审</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="开始时间" prop="startTime" min-width="160" />
      <el-table-column align="center" label="结束时间" prop="endTime" min-width="160" />
      <el-table-column align="center" label="操作人" prop="operator" min-width="100" />
      <el-table-column align="center" label="总订单数" prop="totalOrders" min-width="80" />
      <el-table-column align="center" label="入住数" prop="totalCheckin" min-width="80" />
      <el-table-column align="center" label="退房数" prop="totalCheckout" min-width="80" />
      <el-table-column align="center" label="总收入" prop="totalRevenue" min-width="100">
        <template #default="scope">
          <span style="color: #f56c6c; font-weight: bold;">
            {{ scope.row.totalRevenue != null ? '￥' + scope.row.totalRevenue : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" prop="status" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.status === 'PENDING'" type="info">待执行</el-tag>
          <el-tag v-else-if="scope.row.status === 'PROCESSING'" type="warning">执行中</el-tag>
          <el-tag v-else-if="scope.row.status === 'SUCCESS'" type="success">成功</el-tag>
          <el-tag v-else-if="scope.row.status === 'FAILED'" type="danger">失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="错误信息" prop="errorMsg" min-width="160" show-overflow-tooltip />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="150" fixed="right">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:night-audit:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:night-audit:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" filterable clearable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="审核日期" prop="auditDate">
        <el-date-picker
          v-model="formData.auditDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择审核日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="审核类型" prop="auditType">
        <el-radio-group v-model="formData.auditType">
          <el-radio value="DAILY">日审</el-radio>
          <el-radio value="MONTHLY">月审</el-radio>
          <el-radio value="YEARLY">年审</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
          v-model="formData.startTime"
          type="datetime"
          value-format="YYYY-MM-DD HH:mm:ss"
          placeholder="请选择开始时间"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
          v-model="formData.endTime"
          type="datetime"
          value-format="YYYY-MM-DD HH:mm:ss"
          placeholder="请选择结束时间"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="总订单数" prop="totalOrders">
        <el-input-number v-model="formData.totalOrders" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="入住数" prop="totalCheckin">
        <el-input-number v-model="formData.totalCheckin" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="退房数" prop="totalCheckout">
        <el-input-number v-model="formData.totalCheckout" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="总收入" prop="totalRevenue">
        <el-input-number v-model="formData.totalRevenue" :min="0" :precision="2" class="!w-240px" />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio value="PENDING">待执行</el-radio>
          <el-radio value="PROCESSING">执行中</el-radio>
          <el-radio value="SUCCESS">成功</el-radio>
          <el-radio value="FAILED">失败</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="错误信息" prop="errorMsg">
        <el-input
          v-model="formData.errorMsg"
          :rows="3"
          placeholder="请输入错误信息"
          type="textarea"
        />
      </el-form-item>
      <el-form-item label="操作人" prop="operator">
        <el-input v-model="formData.operator" placeholder="请输入操作人" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="formData.remark"
          :rows="3"
          placeholder="请输入备注"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>

  <Dialog v-model="executeDialogVisible" title="执行夜审">
    <el-form ref="executeFormRef" :model="executeFormData" :rules="executeFormRules" label-width="100px">
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="executeFormData.shopId" placeholder="请选择店铺" filterable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="审核日期" prop="auditDate">
        <el-date-picker
          v-model="executeFormData.auditDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择审核日期"
          class="!w-240px"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="executeLoading" type="primary" @click="submitExecute">执 行</el-button>
      <el-button @click="executeDialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as NightAuditApi from '@/api/hotel/nightAudit'
import { getShopSimpleList } from '@/api/hotel/platformShop'

defineOptions({ name: 'HotelNightAudit' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  auditDate: undefined,
  auditType: undefined,
  status: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await NightAuditApi.getNightAuditPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const executeDialogVisible = ref(false)
const executeLoading = ref(false)
const executeFormRef = ref()
const executeFormData = reactive<any>({
  shopId: undefined,
  auditDate: undefined
})
const executeFormRules = reactive({
  shopId: [{ required: true, message: '请选择店铺', trigger: 'change' }],
  auditDate: [{ required: true, message: '请选择审核日期', trigger: 'change' }]
})

const openExecuteDialog = () => {
  executeFormData.shopId = undefined
  executeFormData.auditDate = undefined
  executeDialogVisible.value = true
}

const submitExecute = async () => {
  await executeFormRef.value.validate()
  executeLoading.value = true
  try {
    await NightAuditApi.executeNightAudit(executeFormData.shopId, executeFormData.auditDate)
    message.success('夜审执行成功')
    executeDialogVisible.value = false
    await getList()
  } finally {
    executeLoading.value = false
  }
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<NightAuditApi.NightAuditVO>({
  id: undefined,
  shopId: undefined,
  auditDate: '',
  auditType: 'DAILY',
  startTime: undefined,
  endTime: undefined,
  status: 'PENDING',
  totalOrders: 0,
  totalRevenue: 0,
  totalCheckin: 0,
  totalCheckout: 0,
  errorMsg: '',
  operator: '',
  remark: '',
  createTime: undefined as any
})
const formRules = reactive({
  auditDate: [{ required: true, message: '审核日期不能为空', trigger: 'change' }],
  auditType: [{ required: true, message: '审核类型不能为空', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await NightAuditApi.getNightAudit(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await NightAuditApi.createNightAudit(data)
      message.success(t('common.createSuccess'))
    } else {
      await NightAuditApi.updateNightAudit(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    shopId: undefined,
    auditDate: '',
    auditType: 'DAILY',
    startTime: undefined,
    endTime: undefined,
    status: 'PENDING',
    totalOrders: 0,
    totalRevenue: 0,
    totalCheckin: 0,
    totalCheckout: 0,
    errorMsg: '',
    operator: '',
    remark: '',
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await NightAuditApi.deleteNightAudit(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
  getShopList()
})
</script>
